// extracted by mini-css-extract-plugin
export default {"container":"dashboardButtonCard_container__XTs9R","gradient":"dashboardButtonCard_gradient__URbSW","textContent":"dashboardButtonCard_textContent__y+CgX"};